export enum MeetingParticipantsType {
    SellerBuyer = 1,
    SellerAdvisor = 2,
    SellerAdminSupport = 3,
    BuyerAdminSupport = 4,
    AdvisorAdminSupport = 5,
    BuyerAdvisor = 6,
    BuyerSellerAdvisor = 7,
}

export const MeetingParticipantsTypesOptions = {
    [MeetingParticipantsType.SellerBuyer]: 'Seller / Buyer',
    [MeetingParticipantsType.SellerAdvisor]: 'Seller / Advisor',
    [MeetingParticipantsType.SellerAdminSupport]: 'Seller / Admin Support',
    [MeetingParticipantsType.BuyerAdminSupport]: 'Buyer / Admin Support',
    [MeetingParticipantsType.AdvisorAdminSupport]: 'Advisor / Admin Support',
    [MeetingParticipantsType.BuyerAdvisor]: 'Buyer / Advisor',
    [MeetingParticipantsType.BuyerSellerAdvisor]: 'Buyer / Seller / Advisor',
};

export const AdminMeetingParticipantsTypesOptions = {
    [MeetingParticipantsType.SellerAdminSupport]: 'Seller / Admin Support',
    [MeetingParticipantsType.BuyerAdminSupport]: 'Buyer / Admin Support',
    [MeetingParticipantsType.AdvisorAdminSupport]: 'Advisor / Admin Support',
    [MeetingParticipantsType.BuyerSellerAdvisor]: 'Buyer / Seller / Advisor',
};

export const BrokerMeetingParticipantsTypesOptions = {
    [MeetingParticipantsType.SellerAdvisor]: 'Seller / Advisor',
    [MeetingParticipantsType.BuyerAdvisor]: 'Buyer / Advisor',
};

export const getMeetingParticipantsTypesOptionsForUser = (
    isAdmin: boolean,
    isBroker: boolean,
    isBrokerExist: boolean,
    allowedParticipantTypes?: MeetingParticipantsType[]
): { [key: number]: string } => {
    let options: { [key: number]: string };
    if (isAdmin) {
        options = { ...AdminMeetingParticipantsTypesOptions };
        if (!isBrokerExist) {
            delete options[MeetingParticipantsType.AdvisorAdminSupport];
        }
    } else if (isBroker) {
        options = BrokerMeetingParticipantsTypesOptions;
    } else {
        options = MeetingParticipantsTypesOptions;
    }

    if (!allowedParticipantTypes) {
        return options;
    }

    return Object.fromEntries(
        Object.entries(options).filter(([key]) =>
            allowedParticipantTypes.includes(Number(key) as MeetingParticipantsType)
        )
    );
};

export const EngagementMeetingTypeHeaderColor = {
    [MeetingParticipantsType.SellerBuyer]: '#fb9191',
    [MeetingParticipantsType.SellerAdvisor]: '#fb9191',
    [MeetingParticipantsType.SellerAdminSupport]: '#fb9191',
    [MeetingParticipantsType.BuyerAdminSupport]: '#fb9191',
    [MeetingParticipantsType.AdvisorAdminSupport]: '#fb9191',
    [MeetingParticipantsType.BuyerAdvisor]: '#fb9191',
    [MeetingParticipantsType.BuyerSellerAdvisor]: '#fb9191',
} as const;

export const EngagementMeetingTypeBodyColor = {
    [MeetingParticipantsType.SellerBuyer]: '#fff3f3',
    [MeetingParticipantsType.SellerAdvisor]: '#fff3f3',
    [MeetingParticipantsType.SellerAdminSupport]: '#fff3f3',
    [MeetingParticipantsType.BuyerAdminSupport]: '#fff3f3',
    [MeetingParticipantsType.AdvisorAdminSupport]: '#fff3f3',
    [MeetingParticipantsType.BuyerAdvisor]: '#fff3f3',
    [MeetingParticipantsType.BuyerSellerAdvisor]: '#fff3f3',
} as const;